interface GlobalEnv {
  fundAccountingRoute: string;
  serviceRequestRoute: string;
  complianceRoute: string;
  treasuryRoute: string;
  treasuryPlatformManagementRoute: string;
  enablementRoute: string;
  billingRoute: string;
  dataVaultRoute: string;
  dataStudioRoute: string;
  ccToolsRoute: string;
  yourWorkspacesRoute: string;
  controlTowerRoute: string;
  analyticsRoute: string;
  userAndRolesRoute: string;
  reportingRoute: string;
  fayAIRoute: string;
  documentVaultRoute: string;
  dexRoute: string;
  ddqIntakeRoute: string;
}

export const globalEnv: GlobalEnv = {
  fundAccountingRoute: "/fund-accounting",
  serviceRequestRoute: "/service-requests/:id",
  complianceRoute: "/compliance",
  billingRoute: "/billing",
  treasuryRoute: "/treasury",
  treasuryPlatformManagementRoute: "/treasury-platform-management",
  enablementRoute: "/enablement",
  dataVaultRoute: "/data-vault",
  dataStudioRoute: "/data-studio",
  controlTowerRoute: "/control-tower",
  ccToolsRoute: "/cctools",
  yourWorkspacesRoute: "/your-workspaces",
  analyticsRoute: "/analytics",
  userAndRolesRoute: "/users",
  reportingRoute: "/reporting",
  fayAIRoute: "/admin-oversight-agent",
  documentVaultRoute: "/document-vault",
  dexRoute: "/dex",
  ddqIntakeRoute: "/ddq/intake",
};
